import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';

const severityConfig = {
  info: {
    icon: <InfoIcon sx={{ color: '#0288d1', fontSize: 32 }} />,
    title: 'Information',
    color: '#0288d1',
  },
  success: {
    icon: <CheckCircleIcon sx={{ color: '#2e7d32', fontSize: 32 }} />,
    title: 'Success',
    color: '#2e7d32',
  },
  warning: {
    icon: <WarningIcon sx={{ color: '#ed6c02', fontSize: 32 }} />,
    title: 'Warning',
    color: '#ed6c02',
  },
  error: {
    icon: <ErrorIcon sx={{ color: '#d32f2f', fontSize: 32 }} />,
    title: 'Error',
    color: '#d32f2f',
  },
};

const NotificationDialog = ({ open, message, onClose, severity = 'info' }) => {
  const { icon, title, color } = severityConfig[severity] || severityConfig.info;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, color }}>
        {icon}
        {title}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} autoFocus sx={{ color }}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotificationDialog;
